import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import IconTextField from "./IconTextField";
import { AccountCircle, EmailOutlined } from "@mui/icons-material";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import { verifyDealer } from "../services/dealerServices";
import {
  disableUser,
} from "../services/dealerRegisterServices";
import { userSignup } from "../services/signupService";
import JbwSwitch from "./JbwSwitch";
import { getTenantByfDealerId } from "../services/tenantServices";
import TenantsMultiSelect from "./TenantsMultiSelect";
import BusinessUnitSelect from "./BusinessUnitSelect";
import { AuthContext } from "../AuthContext";


const UserRegistrationDialog = ({
  onClose,
  open,
  isEdit = false,
  userData,
}) => {
  const { APP_ENV } = useContext(AuthContext);
  const [titelText, setTitelText] = useState("Dealer");
  const [roleValue, setRoleValue] = useState("jbw-dealer");
  const [fieldAf, setFieldAf] = useState(true);
  const [dealerId, setDealerId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [fullNameErr, setFullNameErr] = useState("");
  const [companyNameErr, setCompanyNameErr] = useState("");
  const [dealerIdErr, setDealerIdErr] = useState("");
  const [dealerErr, setDealerErr] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(true);
  const [disableDealerId, setDisableDealerId] = useState(false);
  const [disableRadio, setDisableRadio] = useState(false);
  const [hideisActive, setHideIsActive] = useState(false);
  const [isActiveChecked, setIsActiveChecked] = useState(false);
  const [disableisActive, setDisableIsActive] = useState(false);
  const [isPrimaryChecked, setIsPrimaryChecked] = useState(false);
  const [disableisPrimary, setDisableIsPrimary] = useState(false);
  const [emailOptInChecked, setEmailOptInChecked] = useState(false);
  const [disableEmailOptIn, setDisableEmailOptIn] = useState(false);
  const [disableUpdate, setDisableUpdate] = useState(true);
  const [id, setId] = useState("");
  const [disableCancel, setDisableCancel] = useState(false);
  const [tenantList, setTenantList] = useState([]);
  const [selectedTenants, setSelectedTenants] = useState([]);
  const [showTenantField, setShowTenantField] = useState(false);
  const [disableTenantField, setDisableTenantField] = useState(false);
  const [businessUnitList, setBusinessUnitListList] = useState([]);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState([]);
  const [showBusinessUnitField, setShowBusinessUnitField] = useState(false);
  const [disableBusinessUnitField, setDisableBusinessUnitField] =
    useState(false);
  const [crmSystem, setCrmSystem] = useState("");
  const [emailOptType, setEmailOptType] = useState(null);

  // A dealer's primary contact can't be switched off here, but can be switched back on:
  // deactivating the dealer's last tenant deactivates every user, this one included
  // (jbwdealeradmintoolsupdate), and this switch is the only way to reactivate them.
  // Unlocked only on an explicit 0: isActive is a nullable tinyint, and a NULL row stays
  // locked as before.
  const isActiveLocked =
    isEdit &&
    userData?.isPrimary === 1 &&
    userData?.roleValue === "Dealer" &&
    userData?.isActive !== 0;

  useEffect(() => {
    console.log("Is Edit :", isEdit);

    if (isEdit && userData) {
      setId(userData.id);
      if (userData.roleValue === "Dealer") {
        setRoleValue("jbw-dealer");
        setFieldAf(true);
        // getTenants();
        if (userData.TenantsDetails.length > 0) {
          setShowTenantField(true);
        }
      } else {
        setRoleValue("jbw-admin");
        setFieldAf(false);
      }
      setDealerId(userData.dealerId);
      setTenantList(userData.TenantsDetails);
      if (userData.TenantsDetails.length > 0) {
        const filteredTenants = userData.TenantsDetails?.filter((dt) => {
          //console.log("Tenant List form userData ", userData.TenantsDetails);
          const isInclude = userData.tenantId?.includes(dt.tenantId);
          // console.log(`data tenant : ${dt.tenantId} is ${isInclude}`);
          return isInclude ? dt : null;
        });
        console.log("filtered Tenants : ", filteredTenants);
        setSelectedTenants(filteredTenants?.map((ft) => ft.tenantId));
        //setSelectedTenants(...userData.tenantId);
        const bunits = filteredTenants
          ?.filter((ft) => ft.businessUnits)
          .flatMap((ft) => ft.businessUnits);
        console.log("filtered BusinessUnits : ", bunits);
        if (bunits.length > 0) {
          setBusinessUnitListList([...bunits]);
          setShowBusinessUnitField(true);
          console.log("saved business units : ", userData.businessUnit);
          if (userData.businessUnit && userData.businessUnit.length > 0) {
            const filteredBus = bunits.filter((bu) =>
              userData.businessUnit?.includes(bu.businessUnitId)
            );
            console.log("selected business units :", filteredBus);
            setSelectedBusinessUnit(
              filteredBus?.map((bu) => bu.businessUnitId)
            );
          }
        }
      }

      setDisableDealerId(true);
      setDisableRadio(true);
      setHideIsActive(true);
      setDealerErr("");

      setIsActiveChecked(userData.isActive === 1 ? true : false);
      setIsPrimaryChecked(userData.isPrimary === 1 ? true : false);
      setEmailOptInChecked(userData.emailOptIn === 1 ? true : false);
      setEmailOptType(userData.emailOptInFrequency);
      if (userData.isPrimary === 1) {
        console.log("Role Value ", roleValue);
        setDisableIsActive(isActiveLocked);
        setDisableIsPrimary(true);
      } else {
        setDisableIsActive(false);
        setDisableIsPrimary(false);
      }
      setCompanyName(userData.companyName);
      setFullName(userData.fullName);
      setEmail(userData.email);

      setTitelText(userData.roleValue);
      // setIsFormSubmitted(true);
    } else {
      //setHideIsActive(false);
      resetForm();
      //setDisableIsActive(true);
      setDisableIsPrimary(false);
    }
  }, [isEdit, userData, isActiveLocked]);
  const formInputChange = (formField, value) => {
    if (formField === "email") {
      setEmail(value);
    }
    if (formField === "fullName") {
      setFullName(value);
    }
    if (formField === "companyName") {
      setCompanyName(value);
    }
    if (formField === "dealerId") {
      setDealerId(value);
    }
  };

  const getTenants = () => {
    console.log("loading tenant list");
    setTenantList([]);
    getTenantByfDealerId(dealerId)
      .then(
        (res) => {
          let data = res.data;
          if (data && data.length > 0) {
            setTenantList(data);
            if (isEdit) {
              const filteredTenants = data
                .filter((dt) => {
                  console.log("Tenant List form userData ", userData);
                  const isInclude = userData.tenantId?.includes(dt.tenantId);
                  console.log(`data tenant : ${dt.tenantId} is ${isInclude}`);
                  return isInclude ? dt : null;
                })
                .map((ft) => ft.tenantId);
              console.log("filtered Tenants : ", filteredTenants);
              setSelectedTenants(filteredTenants);
            }
          }
        },
        (err) => {
          console.log("Unable retrive tenats data", err);
        }
      )
      .catch((err) => {
        console.error("tenant service Error :", err);
      });
  };

  // useEffect(() => {
  //   if (dealerId) {
  //     getTenants();
  //   }
  // }, [dealerId]);

  const handleSelectedTenantChange = (newTenant) => {
    //console.log("selected tenant :", newTenant);
    //console.log(" tenant list :", tenantList);

    setSelectedTenants(newTenant);

    const filteredTenant = tenantList?.filter((tl) =>
      newTenant?.includes(tl.tenantId)
    );
    console.log("filteredTenant :", filteredTenant[0]?.businessUnits);
    const businessUnits =
      filteredTenant?.length > 0 ? filteredTenant[0]?.businessUnits : [];
    setBusinessUnitListList(businessUnits);
    setShowBusinessUnitField(true);
    if (isEdit) {
      setDisableUpdate(false);
    }
  };

  const handleSelectedBusinessUnitChange = (newBu) => {
    setSelectedBusinessUnit(newBu);
    if (isEdit) {
      setDisableUpdate(false);
    }
  };

  const dealerIdValidation = () => {
    return new Promise((resolve, reject) => {
      if (dealerId === "") {
        setDealerIdErr("Dealer ID required");
        resolve({ dealerId: "Dealer Id required" });
      } else {
        resolve({ dealerId: "" });
      }
      reject("");
    });
  };

  const validation = () => {
    return new Promise((resolve, reject) => {
      if (roleValue === "jbw-dealer" && companyName === "" && dealerId === "") {
        setEmailErr("Email is Required");
        setFullNameErr("Full Name is Required");
        setCompanyNameErr("Company Name is Required");
        setDealerIdErr("Dealer ID is Required");
        resolve({
          email: "Email is Required",
          fullName: "Full Name is Required",
          companyName: "Company Name is Required",
          dealerId: "Dealer ID is Required",
        });
      } else if (roleValue === "jbw-admin" && email === "" && fullName === "") {
        setEmailErr("Email is Required");
        setFullNameErr("Full Name is Required");
        resolve({
          email: "Email is Required",
          password: "Password is required",
          fullName: "Full Name is Required",
        });
      } else if (email === "") {
        setEmailErr("Email is Required");
        resolve({
          email: "Email is Required",
          fullName: "",
          companyName: "",
          dealerId: "",
        });
      } else if (fullName === "") {
        setFullNameErr("Full Name is required");
        resolve({
          email: "",
          fullName: "Full Name is required",
          companyName: "",
          dealerId: "",
        });
      } else if (roleValue === "jbw-dealer" && dealerId === "") {
        setDealerIdErr("Dealer ID is required");
        resolve({
          email: "",
          fullName: "",
          companyName: "",
          dealerId: "Dealer ID is required",
        });
      } else if (roleValue === "jbw-dealer" && companyName === "") {
        setCompanyNameErr("Company Name is required");
        setDealerErr("Please valid Dealer ID to Populate Company Name");
        resolve({
          email: "",
          fullName: "",
          companyName: "Company Name is required",
          dealerId: "",
        });
      } else {
        resolve({
          email: "",
          fullName: "",
          companyName: "",
          dealerId: "",
        });
      }
      reject("");
    });
  };

  const handleVerifyDealer = (dealerId) => {
    if (isEdit) {
      return;
    }
    setCompanyName("");
    setEmailErr("");
    setFullNameErr("");
    setCompanyNameErr("");
    setDealerIdErr("");
    setDealerErr("");
    setDisableDealerId(true);
    setDisableCancel(true);
    setDisableRadio(true);
    dealerIdValidation()
      .then(
        (res) => {
          console.log(res);
          if (res.dealerId === "") {
            verifyDealer(dealerId)
              .then(
                (res) => {
                  console.log("verifyDealer :", res);
                  let data = res.data;
                  if (data && data.length > 0) {
                    console.log(
                      "tenant details from verifydealer :",
                      data[0].TenantsDetails !== null
                    );
                    let tempTenantDetails =
                      data[0].TenantsDetails !== null
                        ? typeof data[0].TenantsDetails === "string"
                          ? JSON.parse(data[0].TenantsDetails)
                          : data[0].TenantsDetails
                        : [];
                    setTenantList(tempTenantDetails);
                    if (tempTenantDetails.length === 1) {
                      setSelectedTenants([tempTenantDetails[0].tenantId]);
                    }
                    setCompanyName(data[0].dealerName);
                    setShowTenantField(tempTenantDetails.length > 0);
                    setCrmSystem(data[0].crmSystem);
                    setIsFormSubmitted(false);
                    setDisableDealerId(false);
                    setDisableCancel(false);
                    setDisableRadio(false);
                  } else {
                    setIsFormSubmitted(true);
                    setDisableDealerId(false);
                    setDisableCancel(false);
                    setDisableRadio(false);
                    setDealerIdErr(
                      "No dealer Found with given Dealer ID, Please Login to JB Warranties and check the Dealer Id"
                    );
                  }
                },
                (err) => {
                  console.log(err);
                  setDealerErr("Error in verifying the dealer");
                  setDisableDealerId(false);
                  setDisableCancel(false);
                  setDisableRadio(false);
                }
              )
              .catch((err) => {
                console.log(err);
                setDealerErr("Ineternal error try again");
                setDisableDealerId(false);
                setDisableCancel(false);
                setDisableRadio(false);
              });
            // verifyDealerRegistration(dealerId)
            //   .then(
            //     (dr) => {
            //       let da = dr.data;
            //       if (da && da.length > 0) {
            //         setDealerIdErr(
            //           "Dealer already registrated.You can login using existing Credentials"
            //         );
            //         setDisableDealerId(false);
            //         setDisableCancel(false);
            //         setDisableRadio(false);
            //       } else {

            //       }
            //     },
            //     (err) => {
            //       console.log(err);
            //       setDealerErr("Unable to verify dealer registration");
            //       setDisableDealerId(false);
            //       setDisableCancel(false);
            //       setDisableRadio(false);
            //     }
            //   )
            //   .catch((err) => {
            //     console.log(err);
            //     setDisableDealerId(false);
            //     setDisableCancel(false);
            //     setDisableRadio(false);
            //     setDealerErr("Ineternal error try again");
            //   });
          } else {
            setDisableDealerId(false);
            setDisableCancel(false);
            setDisableRadio(false);
          }
        },
        (err) => {
          console.log(err);
          setDisableDealerId(false);
          setDisableCancel(false);
          setDisableRadio(false);
        }
      )
      .catch((err) => {
        setDisableDealerId(false);
        setDisableCancel(false);
        console.log(err);
      });
  };

  const handleRoleChange = (event) => {
    resetForm();
    const role = event.target.value;
    if (role === "jbw-dealer") {
      setTitelText("Dealer");
      setIsFormSubmitted(true);
      setFieldAf(true);
    } else {
      setTitelText("Admin");
      setIsFormSubmitted(false);
      setFieldAf(false);
    }
    setRoleValue(role);
  };

  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    resetForm();
    onClose("closed");
  };

  const handleisActiveChecked = (e) => {
    setIsActiveChecked(e);
    setDisableUpdate(false);
    console.log("active status changed ->", e);
  };

  const handleisPrimaryChecked = (e) => {
    setIsPrimaryChecked(e);
    setDisableUpdate(false);
    console.log("primary status changed ->", e);
  };
  const handleEmailOptInChecked = (e) => {
    setEmailOptInChecked(e);
    setDisableUpdate(false);
    setEmailOptType("Daily");
    if (!e) {
      setEmailOptType(null); // reset when turned off
    }
    console.log("emailOptIn status changed ->", e);
  };

  const handleEmailOptTypeChange = (event) => {
    const value = event.target.value;
    setEmailOptType(value);

    if (isEdit) {
      setDisableUpdate(false);
    }
  };

  const handleRegister = () => {
    console.log("register called");
    // setCompanyName("");
    setEmailErr("");
    setFullNameErr("");
    setCompanyNameErr("");
    setDealerIdErr("");
    setDealerErr("");
    setIsFormSubmitted(true);
    setDisableCancel(true);
    setDisableRadio(true);
    setDisableIsActive(true);
    setDisableIsPrimary(true);
    setDisableEmailOptIn(true);
    setDisableTenantField(true);
    if (isEdit) {
      setDisableUpdate(true);
      const reqData = {
        email: email,
        id: id,
        dealerId: dealerId,
        isActive: isActiveChecked,
        isPrimary: isPrimaryChecked,
        emailOptIn: emailOptInChecked,
        emailOptType: emailOptType,
        tenants: crmSystem !== "Workiz" ? selectedTenants : [],
        businessUnits:
          crmSystem !== "Workiz" && selectedTenants.length > 0
            ? selectedBusinessUnit
            : [],
      };
      disableUser(reqData)
        .then(
          (res) => {
            console.log(res.data);
            const data = res.data;
            if (res.status === 200) {
              setIsFormSubmitted(false);
              setDisableDealerId(false);
              setDisableTenantField(false);
              resetForm();
              onClose("userCreated");
            } else if (res.status === 500) {
              const message = data;
              setIsActiveChecked(userData.isActive === 1 ? true : false);
              setDisableUpdate(true);
              setDisableCancel(false);
              setDisableTenantField(false);
              setDisableIsActive(isActiveLocked);
              setDisableIsPrimary(false);
              setDisableEmailOptIn(false);
              console.log("Error disabling user :", message);
              setDealerErr(data);
            } else {
              setIsActiveChecked(userData.isActive === 1 ? true : false);
              setDisableUpdate(true);
              setDisableCancel(false);
              setDisableTenantField(false);
              setDisableIsActive(isActiveLocked);
              setDisableIsPrimary(false);
              setDisableEmailOptIn(false);
              setDealerErr("Server time out please try again");
            }
          },
          (err) => {
            setIsActiveChecked(userData.isActive === 1 ? true : false);
            setDisableUpdate(true);
            setDisableCancel(false);
            setDisableTenantField(false);
            setDisableIsActive(isActiveLocked);
            setDisableIsPrimary(false);
            setDisableEmailOptIn(false);
            console.log("Error disabling user :", err);
            setDealerErr(`Unable to disable ${titelText}  User`);
          }
        )
        .catch((err) => {
          setIsActiveChecked(userData.isActive === 1 ? true : false);
          setDisableUpdate(true);
          setDisableCancel(false);
          setDisableTenantField(false);
          setDisableIsActive(isActiveLocked);
          setDisableIsPrimary(false);
          setDisableEmailOptIn(false);
          console.error("Error calling disable user service", err);
          setDealerErr("Internal server error");
        });
    } else {
      console.log("new user creation");
      validation()
        .then(
          (res) => {
            console.log("new registration res", res);
            if (
              res.email === "" &&
              res.fullName === "" &&
              res.companyName === "" &&
              res.dealerId === ""
            ) {
              console.log("new registration validation passed");
              const userData = {
                email: email,
                fullname: fullName,
                profile: dealerId,
                companyname: companyName,
                group: roleValue,
                tenants: crmSystem !== "Workiz" ? selectedTenants : [],
                businessUnits:
                  crmSystem !== "Workiz" ? selectedBusinessUnit : [],
                isPrimary: isPrimaryChecked,
                emailOptIn: emailOptInChecked,
                emailOptType: emailOptType,
              };
              userSignup(userData)
                .then(
                  (res) => {
                    console.log("UserSignUp response :", res);
                    const statusCode =
                      APP_ENV === "Development"
                        ? res.data.statusCode
                        : res.status;
                    console.log("usersignup response status ::", statusCode);
                    if (statusCode !== 200) {
                      setIsFormSubmitted(false);
                      setDisableDealerId(false);
                      setDisableCancel(false);
                      setDisableRadio(false);
                      setDisableTenantField(false);
                      setDisableIsActive(false);
                      setDisableIsPrimary(false);
                      setDisableEmailOptIn(false);
                      const errMag =
                        APP_ENV === "Development"
                          ? JSON.parse(res.data.body).message
                          : JSON.parse(res.data).message;
                      console.log("signup errpr msg : ", errMag);
                      setDealerErr(errMag);
                      return;
                    }
                    console.log("usersignup response", res);
                    setIsFormSubmitted(false);
                    setDisableDealerId(false);
                    setDisableTenantField(false);
                    resetForm();
                    onClose("userCreated");
                  },
                  (err) => {
                    console.log("Error registring user :", err);
                    setIsFormSubmitted(false);
                    setDisableDealerId(false);
                    setDisableCancel(false);
                    setDisableRadio(false);
                    setDisableIsActive(false);
                    setDisableIsPrimary(false);
                    setDisableEmailOptIn(false);
                    // setDisableTenantField(false);
                    console.log(
                      "unable to signup user :",
                      err.response.data.message
                    );
                    setDealerErr(err?.response?.data?.message);
                  }
                )
                .catch((err) => {
                  console.error("Error calling sign up service", err);
                  setIsFormSubmitted(false);
                  setDisableDealerId(false);
                  setDisableCancel(false);
                  setDisableRadio(false);
                  setDisableIsActive(false);
                  setDisableIsPrimary(false);
                  setDisableEmailOptIn(false);
                  setDealerErr("Internal server error");
                });
            } else {
              setIsFormSubmitted(false);
              setDisableDealerId(false);
              setDisableRadio(false);
              setDisableCancel(false);
              setDisableIsActive(false);
              setDisableIsPrimary(false);
              setDisableEmailOptIn(false);
            }
          },
          (err) => {
            console.log(err);
            setIsFormSubmitted(false);
            setDisableDealerId(false);
            setDisableRadio(false);
            setDisableCancel(false);
            setDisableIsActive(false);
            setDisableIsPrimary(false);
            setDisableEmailOptIn(false);
          }
        )
        .catch((err) => {
          console.log(err);
          setIsFormSubmitted(false);
          setDisableDealerId(false);
          setDisableRadio(false);
          setDisableIsActive(false);
          setDisableIsPrimary(false);
          setDisableEmailOptIn(false);
          setDisableCancel(false);
        });
    }
  };

  const resetForm = () => {
    setRoleValue("jbw-dealer");
    setEmailErr("");
    setFullNameErr("");
    setCompanyNameErr("");
    setDealerIdErr("");
    setEmail("");
    setFullName("");
    setCompanyName("");
    setDealerId("");
    setDisableCancel(false);
    setDisableRadio(false);
    setDealerErr("");
    setDisableDealerId(false);
    setIsActiveChecked(false);
    setIsPrimaryChecked(false);
    setEmailOptInChecked(false);
    setShowTenantField(false);
    setSelectedTenants([]);
    setTenantList([]);
    setDisableTenantField(false);
    setShowBusinessUnitField(false);
    setBusinessUnitListList([]);
    setSelectedBusinessUnit([]);
    setDisableBusinessUnitField(false);
    setHideIsActive(false)
    setDisableEmailOptIn(false);
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>{titelText} Registration</DialogTitle>
      <DialogContent>

        <Box component="form" noValidate sx={{ pl: 3, pr: 3 }}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item xs={12} sm={6} md={6}>
              <FormControl
                fullWidth
                sx={{
                  "& .MuiFormControl-root": {
                    display: "inline-block",
                    float: "right",
                  },
                }}
              >
                <FormLabel id="role-radio-group-label" sx={{ maxWidth: 70 }}>
                  Role
                </FormLabel>

                <RadioGroup
                  row
                  aria-labelledby="role-radio-group-label"
                  name="row-radio-buttons-group"
                  value={roleValue}
                  onChange={handleRoleChange}
                  sx={{ maxWidth: 200 }}
                >
                  <FormControlLabel
                    value="jbw-dealer"
                    control={<Radio />}
                    label="Dealer"
                    disabled={disableRadio ? true : false}
                  />
                  <FormControlLabel
                    value="jbw-admin"
                    control={<Radio />}
                    label="Admin"
                    disabled={disableRadio ? true : false}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {roleValue === "jbw-dealer" && (
              <>
                <Grid item xs={12} sm={6} md={6}>
                  <IconTextField
                    iconStart={
                      <BadgeIcon sx={{ color: "#bdbdbd", fontSize: 20 }} />
                    }
                    autoFocus={fieldAf}
                    margin="normal"
                    id="dealerId"
                    label="Dealer ID"
                    type="text"
                    fullWidth
                    value={dealerId}
                    onChange={(e) =>
                      formInputChange("dealerId", e.target.value)
                    }
                    onBlur={(e) => handleVerifyDealer(e.target.value)}
                    error={dealerIdErr ? true : false}
                    helperText={dealerIdErr}
                    size="small"
                    disabled={disableDealerId ? true : false}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <IconTextField
                    iconStart={
                      <BusinessIcon sx={{ color: "#bdbdbd", fontSize: 20 }} />
                    }
                    margin="normal"
                    id="companyName"
                    label="Company Name"
                    type="text"
                    fullWidth
                    value={companyName}
                    onChange={(e) =>
                      formInputChange("companyName", e.target.value)
                    }
                    disabled={true}
                    error={companyNameErr ? true : false}
                    helperText={companyNameErr}
                    size="small"
                  />
                </Grid>
                {/* {showTenantField && tenantList?.length > 0 && (
                  <Grid item xs={12} sm={6} md={6}>
                    <TenantsMultiSelect
                      tenants={tenantList}
                      selectedValues={selectedTenants}
                      onChange={handleSelectedTenantChange}
                      disabled={disableTenantField}
                    />
                  </Grid>
                )} */}

                {showTenantField &&
                  (tenantList?.length > 0 ? (
                    <Grid item xs={12} sm={6} md={6}>
                      <TenantsMultiSelect
                        tenants={tenantList}
                        selectedValues={selectedTenants}
                        onChange={handleSelectedTenantChange}
                        disabled={disableTenantField}
                      />
                    </Grid>
                  ) : (
                    <Typography
                      color="primary"
                      sx={{ flex: 1, flexDirection: "column", gap: 3 }}
                    >
                      <CircularProgress size="15px" />
                      Loading TenantList...
                    </Typography>
                  ))}

                {showBusinessUnitField && businessUnitList?.length > 0 && (
                  <Grid item xs={12} sm={6} md={6}>
                    <BusinessUnitSelect
                      businessUnits={businessUnitList}
                      selectedValues={selectedBusinessUnit}
                      onChange={handleSelectedBusinessUnitChange}
                      disabled={disableBusinessUnitField}
                      multiselect={true}
                    />
                  </Grid>
                )}
              </>
            )}

            <Grid item xs={12} sm={6} md={6}>
              <IconTextField
                iconStart={
                  <AccountCircle sx={{ color: "#bdbdbd", fontSize: 20 }} />
                }
                autoFocus={!fieldAf}
                margin="normal"
                id="fullName"
                label="Full Name"
                type="fullName"
                fullWidth
                value={fullName}
                onChange={(e) => formInputChange("fullName", e.target.value)}
                error={fullNameErr ? true : false}
                helperText={fullNameErr}
                size="small"
                disabled={isFormSubmitted ? true : false}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <IconTextField
                iconStart={
                  <EmailOutlined sx={{ color: "#bdbdbd", fontSize: 20 }} />
                }
                margin="normal"
                id="name"
                label="Email Address"
                type="email"
                fullWidth
                value={email}
                onChange={(e) => formInputChange("email", e.target.value)}
                error={emailErr ? true : false}
                helperText={emailErr}
                size="small"
                disabled={isFormSubmitted ? true : false}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Stack direction="row" alignItems="center">
                {hideisActive && (
                  <>
                    <Typography variant="body2" component="div" sx={{ mr: 1 }}>
                      Active Status :
                    </Typography>
                    <JbwSwitch
                      isChecked={handleisActiveChecked}
                      setChecked={isActiveChecked}
                      id={id.toString()}
                      isDisabled={disableisActive}
                    />
                  </>
                )}

                <>
                  {roleValue === "jbw-dealer" && (
                    <>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{ mr: 1 }}
                      >
                        Is Primary :
                      </Typography>
                      <JbwSwitch
                        isChecked={handleisPrimaryChecked}
                        setChecked={isPrimaryChecked}
                        id={id.toString()}
                        isDisabled={disableisPrimary}
                      />
                    </>
                  )}
                </>
                <>
                  {roleValue === "jbw-dealer" && (
                    <>
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{ mr: 1 }}
                      >
                        Enable Email Notification :
                      </Typography>
                      <JbwSwitch
                        isChecked={handleEmailOptInChecked}
                        setChecked={emailOptInChecked}
                        id={id.toString()}
                        isDisabled={disableEmailOptIn}
                      />
                      {emailOptInChecked && (
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                          <Select
                            value={emailOptType}
                            onChange={handleEmailOptTypeChange}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Select</em>
                            </MenuItem>
                            <MenuItem value="Daily">Daily</MenuItem>
                            <MenuItem value="Weekly">Weekly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </>
                  )}
                </>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography
                variant="body"
                sx={{ color: "#f44336", fontSize: "10px" }}
              >
                {dealerErr}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={disableCancel ? true : false}>
          Cancel
        </Button>
        {isEdit ? (
          <Button
            onClick={handleRegister}
            disabled={disableUpdate ? true : false}
          >
            Update
          </Button>
        ) : (
          <Button
            onClick={handleRegister}
            disabled={isFormSubmitted ? true : false}
          >
            Register
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default UserRegistrationDialog;
